import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import SearchTypeahead from 'web/components/SearchTypeahead';
import { commodityList } from 'redux/actions/postLoad';

// import Button from 'web/components/Button';
// import DropDown from 'web/components/DropDown';
// import heroBanner1 from 'web/assets/images/heroBanner1.png';

import './headerContainer.scss';
import Dashboard from '../../pages/private/CommonPages/DashBoard'
const HeaderContainer = ({ searchHandlerEvent, buttonName, userType, title }) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const token = localStorage.getItem('token');

    const [bannerHeightClass, setBannerHeightClass] = useState('buyerBanner');
    const dropDownArr = [
        {
            id: '0',
            label: 'DropDown1',
            value: 'DropDown1',
        },
        {
            id: '1',
            label: 'DropDown2',
            value: 'DropDown2',
        },
    ];

    const postDropDownArr = [
        {
            label: '',
            value: '',
        },
    ];
    // const [resultCommodityList, setGradeCommodityList] = useState(postDropDownArr);
    // const commodityListAPI = async () => {
    //     const response = await dispatch(commodityList(token));
    //     if (response.status === 'SUCCESS') {
    //         if (response.payload.length !== 0) {
    //             const commodityListArr = [];
    //             let obj = {
    //                 label: 'All Commodities',
    //                 value: 'AllCommodities',
    //             }
    //             commodityListArr.push(obj);
    //             for (let i = 0; i < response.payload.length; i++) {
    //                 let obj = {
    //                     label: response.payload[i].commodityName,
    //                     value: response.payload[i].id,
    //                 };
    //                 commodityListArr.push(obj);
    //             }
    //             setGradeCommodityList(commodityListArr);
    //         }
    //     } else {
    //         if (response.message === "Unauthorized (Invalid token)") {
    //             history.push('/sign-in')
    //         }
    //     }
    // };
    // useEffect(() => {
    //     commodityListAPI();
    // }, []);

    const bannerContainer = (classNameSet) => {
        return (
            <Dashboard title={title} />
        )
    }
    return (
        <>
            <div>
                {bannerHeightClass === 'buyerBanner' && bannerContainer('buyerBanner')}
                {bannerHeightClass === 'bannerHeightForSearch' && bannerContainer('bannerHeightForSearch')}
            </div>
        </>
    );
};

export default HeaderContainer;
